export const ADMIN_SESSION_HINT_COOKIE = 'loamify_admin_session_hint';
export const ADMIN_SESSION_HINT_MAX_AGE_SECONDS = 7 * 24 * 60 * 60;
export const ADMIN_SESSION_HINT_MAX_FUTURE_SKEW_MS = 5 * 60 * 1000;

export function isValidAdminSessionHint(value: string | undefined, nowMs = Date.now()): boolean {
  if (!value || !/^\d{13}$/.test(value)) return false;
  const issuedAt = Number(value);
  const ageMs = nowMs - issuedAt;
  return (
    ageMs >= -ADMIN_SESSION_HINT_MAX_FUTURE_SKEW_MS &&
    ageMs <= ADMIN_SESSION_HINT_MAX_AGE_SECONDS * 1000
  );
}

function cookieSecurityAttribute(): string {
  return process.env.NODE_ENV === 'production' ? '; Secure' : '';
}

export function markAdminSessionHintActive(nowMs = Date.now()): void {
  if (typeof document === 'undefined') return;
  document.cookie =
    `${ADMIN_SESSION_HINT_COOKIE}=${nowMs}; Path=/; Max-Age=${ADMIN_SESSION_HINT_MAX_AGE_SECONDS}` +
    `; SameSite=Strict${cookieSecurityAttribute()}`;
}

export function clearAdminSessionHint(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${ADMIN_SESSION_HINT_COOKIE}=; Path=/; Max-Age=0; SameSite=Strict${cookieSecurityAttribute()}`;
}
